// libs
import React, { useMemo } from 'react';

// components
import { Box } from '@lyearn/ui';

// context
import { LearningContentContext } from '../context';
// types
import { LearningContentProps } from '../types';

const LearningContent: React.FC<LearningContentProps> = ({
  content,
  children,
  className,
  onClick,
}) => {
  const value = useMemo(() => ({ content }), [content]);

  return (
    <LearningContentContext.Provider value={value}>
      <Box className={className} onClick={onClick}>
        {children}
      </Box>
    </LearningContentContext.Provider>
  );
};

export default LearningContent;
